import { FormGroupSchema, ControlType } from '@slickss/supplystack-components';

export const collectionFormSchema: FormGroupSchema = {
    id: {
        required: true,
        type: ControlType.Final
    },
    salesOrganization: {
        required: true,
        type: ControlType.Final
    },
    serviceLevel: {
        required: false,
        type: ControlType.Final
    },
    instructions: {
        required: false,
        type: ControlType.Final
    },
    filterAddress: {
        required: false,
        type: ControlType.Final
    },
    filterRecommendedPort: {
        required: false,
        type: ControlType.Final
    },
    selectedAddress: {
        required: true,
        type: ControlType.Final
    },
    quickAddress: {
        required: true,
        type: ControlType.Final
    },
    companyName: {
        required: true,
        type: ControlType.Final
    },
    time: {
        type: ControlType.FormGroup,
        subControl: {
            type: {
                required: true,
                defaultValue: false,
                type: ControlType.Final
            },
            fromHour: {
                /*dependsOn: 'time.type',
                current: 'time.fromHour',
                validator: (dependsOnValue, currentValue) => {
                    return ((!!dependsOnValue && !!currentValue) || !dependsOnValue);
                },*/
                required: false,
                type: ControlType.Final
            },
            fromDate: {
                /* dependsOn: 'time.type',
                current: 'time.fromDate',
                validator: (dependsOnValue, currentValue) => {
                    return ((!!dependsOnValue && !!currentValue) || !dependsOnValue);
                }, */
                required: false,
                type: ControlType.Final
            },
            untilHour: {
                dependsOn: 'time.type',
                current: 'time.untilHour',
                validator: (dependsOnValue, currentValue) => {
                    return ((!!dependsOnValue && !!currentValue) || !dependsOnValue);
                },
                type: ControlType.Final
            },
            untilDate: {
                dependsOn: 'time.type',
                current: 'time.untilDate',
                validator: (dependsOnValue, currentValue) => {
                    return ((!!dependsOnValue && !!currentValue) || !dependsOnValue);
                },
                type: ControlType.Final
            }
        }
    },
    contact: {
        type: ControlType.FormGroup,
        subControl: {
            name: {
                required: true,
                type: ControlType.Final
            },
            email: {
                required: false,
                type: ControlType.FinalEmail
            },
            telephone: {
                type: ControlType.Final
            }
        }
    },
    recommendedPort: {
        required: false,
        type: ControlType.Final
    },
    additionalEmails: {
        required: false,
        type: ControlType.Final
    },

};

export enum AddressType {
    SELECTED_ADDRESS = 'SELECTED_ADDRESS',
    TYPEAHEAD_ADDRESS = 'TYPEAHEAD_ADDRESS',
    EXTENDED_ADDRESS = 'EXTENDED_ADDRESS'
}
